import { Component, OnInit } from '@angular/core';
import { MenuBreadCrumb } from 'brainloper-ui';
@Component({
    selector: 'app-indicators-fuel',
    templateUrl: './indicators-fuel.component.html',
    styleUrls: ['./indicators-fuel.component.scss'],
    standalone: false
})
export class IndicatorsFuelComponent implements OnInit {
  
 public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Indicadores Combustible",
      current: true
    }
  ]

  constructor(
  ) {}

  async ngOnInit() {
  
  }
}
